// extracted by mini-css-extract-plugin
module.exports = {"externalLink":"useUserMenu_externalLink__3HGhe","iframe":"useUserMenu_iframe__2fk9s"};